<template>
	<div class="real-name">
		<!-- 顶部提示 -->
		<div class="real-name__notice">为保证信息真实性，请先进行实名认证，所填写信息仅用于认证，平台将严格保密。</div>

		<!-- 表单 -->
		<div class="real-name__form">
			<van-field
				:value="params.name"
				label="真实姓名"
				placeholder="请输入真实姓名"
				maxlength="20"
				@input="(val) => onInput('name', val)"
			/>
			<van-field
				:value="params.idCard"
				label="身份证号"
				placeholder="请输入身份证号"
				maxlength="18"
				@input="(val) => onInput('idCard', val)"
			/>
		</div>

		<!-- 底部操作栏 -->
		<base-footer background-color="#ffffff">
			<div class="real-name__footer">
				<van-button v-if="loading" type="primary" block loading>提 交</van-button>
				<van-button v-else type="primary" block @click="clickSubmit">提 交</van-button>
				<div
					class="real-name__link"
					@click="clickBackPage"
				>返回</div>
			</div>
		</base-footer>
	</div>
</template>

<script>
import { Dialog } from 'vant'

export default {
	name: 'ActivitySignRealName',
	data: () => ({
		loading: false,
		options: {},
		params: {
			name: '',
			idCard: '',
		},
		userInfo: {},
		isAllowLogin: false,
	}),
	computed: {
		user() {
			return this.$store.getters['user/getLoginInfo']
		},
		// 当前登录医生ID
		doctorId() {
			return this.user.userId || this.user.id || ''
		},
	},
	created() {
		const query = this.$route.query
		if (typeof query.jsonOptions === 'string') {
			try {
				this.options = JSON.parse(query.jsonOptions)
			} catch (e) {
				this.options = {}
			}
		}
		this.getUserInfo(() => {
			// 人脸识别完成回跳后继续执行认证成功回调
			if (query.needContinue && this.userInfo.idcardStatus == 1) {
				this.runCallback()
			}
		})
	},
	methods: {
		// 获取当前登录医生信息（实名认证通过后刷新用户信息）
		getUserInfo(cb = null) {
			if (!this.doctorId) {
				cb && cb()
				return
			}
			this.$api.user.getUserInfo({ id: this.doctorId }).then((res) => {
				if (!res.code && res.data) {
					this.userInfo = res.data
					if (res.data.idcardStatus == 1) {
						this.params.name = res.data.name || ''
						this.params.idCard = res.data.idcard || ''
					}
				}
				cb && cb()
			})
		},
		onInput(key, val) {
			this.params[key] = val
			this.isAllowLogin = this.formVerify()
		},
		// 表单验证
		formVerify() {
			if (!this.params.name) return false
			if (!this.params.idCard) return false
			if (this.params.idCard.length !== 18) return false
			return true
		},
		// 点击前往医生认证
		clickDoctorAuth() {
			// H5 暂无医生认证页，待移植
			this.$router.push('/approve/doctor')
		},
		// 点击提交
		clickSubmit() {
			if (!this.params.name) {
				this.$toast('请输入真实姓名')
				return false
			}
			if (!this.params.idCard) {
				this.$toast('请输入身份证号')
				return false
			}
			if (this.params.idCard.length !== 18) {
				this.$toast('请输入正确的身份证号')
				return false
			}

			this.loading = true
			this.$api.user
				.idCardAuth({
					doctorId: this.doctorId,
					name: this.params.name,
					idCard: this.params.idCard,
				})
				.then((res) => {
					this.loading = false
					if (!res.code) {
						// 认证成功：刷新用户信息后按来源类型继续流程
						this.getUserInfo(this.runCallback)
					} else if (res.code === 100001) {
						Dialog.alert({
							title: '认证失败',
							message: `身份证号已经被手机号${res.msg}的用户占用，如果是您本人手机号，请换手机号登录，如不是您本人手机号，请联系相关项目组人员`,
							confirmButtonText: '我知道了',
						})
					}
				})
				.catch(() => {
					this.loading = false
				})
		},
		// 按来源类型执行认证成功后的回调
		runCallback() {
			let callback = this.naturalFlowRateSubmit
			switch (this.options.type) {
				// 扫描活动二维码分配任务进入
				case 'qrcodeAllocationActivity':
					callback = this.qrcodeAllocationActivitySubmit
					break
				// 扫描活动二维码进入
				case 'qrcodeActivity':
					callback = this.qrcodeActivitySubmit
					break
				// 扫描会议二维码进入
				case 'qrcodeLive':
					callback = this.qrcodLiveSubmit
					break
			}
			callback.call(this)
		},
		// 自然流量用户实名认证处理逻辑
		naturalFlowRateSubmit() {
			Dialog.confirm({
				title: '实名认证成功',
				message: '医生认证通过后，可进行活动参与',
				confirmButtonText: '医生认证',
				cancelButtonText: '返回首页',
			}).then(() => {
				// H5 暂无医生认证页，待移植
				this.$router.push('/approve/doctor')
			}).catch(() => {
				// H5 暂无平台首页，跳转落地页
				this.$router.replace('/landing')
			})
		},
		// 扫描活动二维码分配任务，用户实名认证处理逻辑
		qrcodeAllocationActivitySubmit() {
			Dialog.confirm({
				title: '实名认证成功',
				message: '点击继续完成活动绑定',
				confirmButtonText: '继续',
				cancelButtonText: '返回',
			}).then(() => {
				this.initFace({ need: this.options.faceRecognition, ...this.params }, () => {
					// H5 暂无活动绑定页，待移植
					this.$router.replace({
						path: '/activity/qrcode-detail',
						query: { jsonOptions: JSON.stringify(this.options) },
					})
				})
			}).catch(() => {
				this.initFace({ need: this.options.faceRecognition, ...this.params }, () => {
					this.$router.replace(`${this.options.sourceUrl}?scene=${this.options.projectId}`)
				})
			})
		},
		// 扫描活动二维码用户实名认证处理逻辑
		qrcodeActivitySubmit() {
			Dialog.confirm({
				title: '实名认证成功',
				message: '点击继续完成活动报名',
				confirmButtonText: '继续',
				cancelButtonText: '返回',
			}).then(() => {
				this.initFace({ need: this.options.faceRecognition, ...this.params }, this.getActivityDetail)
			}).catch(() => {
				this.initFace({ need: this.options.faceRecognition, ...this.params }, () => {
					this.$router.replace(`${this.options.sourceUrl}?scene=${this.options.projectId}`)
				})
			})
		},
		// 查询活动信息，判断是否为白名单用户
		getActivityDetail() {
			const activityId = this.options.activityId || (this.options.projectId || '').split('-')[0]
			const params = { id: activityId, doctorId: this.doctorId }
			if (this.options.projectId) params.projectId = this.options.projectId.split('-')[1]
			this.$api.activity.activityDetail(params).then((res) => {
				if (!res.code) {
					if (res.data.enterType == 3 && !res.data.activityDoctorDTO) {
						this.$toast('您暂不可以参与该邀请活动')
						this.qrcodeActivitySubmit()
					} else {
						this.$router.replace(`/activity/sign/audit?activityId=${activityId}`)
					}
				}
			})
		},
		// 扫描会议二维码用户实名认证处理逻辑
		qrcodLiveSubmit() {
			Dialog.confirm({
				title: '实名认证成功',
				message: '点击"返回"继续观看，点击"医生认证"完成认证',
				confirmButtonText: '医生认证',
				cancelButtonText: '返回',
			}).then(() => {
				this.initFace({ need: this.options.faceRecognition, ...this.params }, () => {
					// H5 暂无医生认证页，待移植
					this.$router.replace('/approve/doctor')
				})
			}).catch(() => {
				this.initFace({ need: this.options.faceRecognition, ...this.params }, () => {
					this.$router.replace(`${this.options.sourceUrl}${this.buildQuery(this.options.sourceParams)}`)
				})
			})
		},
		// 人脸识别（需要时才发起，识别完成后回跳本页并携带 needContinue=1 继续流程）
		initFace(data, cb, redirectPath = '') {
			if (!data.need) {
				cb && cb()
				return
			}
			const base = window.location.origin + window.location.pathname
			const redirectUrl = redirectPath
				? base + '#' + redirectPath
				: base + '#' + this.$route.fullPath + (Object.keys(this.$route.query).length ? '&' : '?') + 'needContinue=1'
			this.$api.base
				.faceRecognitionV2({
					name: data.name,
					idNumber: data.idCard,
					sigUrl: encodeURIComponent(redirectUrl),
					callbackUrl: encodeURIComponent(redirectUrl),
				})
				.then((res) => {
					// 用户已经人脸识别过
					if (res.data.code == 20004) {
						cb && cb()
					} else {
						window.location.href = res.data.faceUrl || ''
					}
				})
				.catch(() => {
					this.$toast('人脸识别调用失败，请稍后重试')
				})
		},
		// 拼接 query 字符串
		buildQuery(params = {}) {
			let queryStr = ''
			Object.keys(params).forEach((key, index) => {
				const str = `${key}=${params[key]}`
				queryStr += index > 0 ? '&' + str : '?' + str
			})
			return queryStr
		},
		// 返回来源页
		clickBackPage() {
			this.$router.go(-1)
		},
	},
}
</script>

<style lang="less" scoped>
.real-name {
	min-height: 100vh;
	background-color: #f5f6f7;
	box-sizing: border-box;
	padding-bottom: 20px;

	&__notice {
		padding: 10px 16px;
		font-size: 12px;
		line-height: 18px;
		background-color: #fdf6e6;
		color: #8f959e;
	}

	&__form {
		margin: 12px;
		background-color: #fff;
		border-radius: 6px;
		overflow: hidden;

		.van-field {
			::v-deep .van-field__label {
				width: 100px;
				font-size: 14px;
				color: #1f2329;
			}

			::v-deep .van-field__value {
				font-size: 14px;
				color: #1f2329;
			}
		}
	}

	&__footer {
		width: 100%;
	}

	&__link {
		margin-top: 14px;
		font-size: 14px;
		text-align: center;
		color: var(--color-primary);
	}
}
</style>
